import { Component } from 'react';
import { camelCaseToTitleCase } from '@servicetitan/form';
import { Perform, MAX_MULTISHOW } from './perform';
import { ValuePopover } from './value-popover';

interface PerformEnumMultiSelectProps<T> {
    name: string;
    value?: number[] | undefined;
    enumType: T;
}

export class PerformEnumMultiSelect<T extends { [key: number]: string }> extends Component<
    PerformEnumMultiSelectProps<T>
> {
    isEnumDefined = (item: number) => {
        const { enumType } = this.props;

        return enumType[item] !== undefined;
    };

    convertToString(value: number[]) {
        const { enumType } = this.props;

        return value
            .filter(this.isEnumDefined)
            .map(item => camelCaseToTitleCase(enumType[item]))
            .join(', ');
    }

    convertToArray(value: number[]) {
        const { enumType } = this.props;

        return value.filter(this.isEnumDefined).map(item => camelCaseToTitleCase(enumType[item]));
    }

    render() {
        const { value, name } = this.props;

        if (value && value.length > MAX_MULTISHOW) {
            return (
                <Perform
                    name={name}
                    text={
                        <ValuePopover
                            value={this.convertToArray(value)}
                            title={name}
                            trigger={`${value.filter(this.isEnumDefined).length} selected`}
                        />
                    }
                />
            );
        }

        if (value && value.length <= MAX_MULTISHOW) {
            return <Perform name={name} text={this.convertToString(value)} />;
        }

        return <Perform name={name} text="" />;
    }
}
